<template>
  <b-modal
    :id="id"
    :ref="id"
    :title="title | i18n"
    :ok-title="'save_submit' | i18n"
    ok-variant="primary"
    ok-only
    :ok-disabled="isDisabledSaveBtn"
    button-size="lg"
    size="lg"
    centered
    content-class="rounded-8"
    @ok="save"
    @hide="clear"
  >
    <div class="row">
      <div class="col-lg-12 col-sm-12 col-12">
        <Checkbox
          v-model="isTranslatedChatContent"
          :placeholder="'additional_pdf_chat' | i18n"
          form-group-id="chatContent"
          v-if="!isOnSiteSupportOnly"
        />
      </div>
      <div v-if="isTranslatedChatContent" class="col-lg-6 col-sm-6 col-6 mt-n4">
        <Select
          v-model="firstChatTranslateLanguage"
          :options="languageOptions"
          form-group-id="Language"
          :placeholder="'First language' | i18n"
          input-placeholder="select_translation_lang"
          required
        />
      </div>
      <div v-if="isTranslatedChatContent" class="col-lg-6 col-sm-6 col-6 mt-n4">
        <Select
          v-model="secondChatTranslateLanguage"
          :options="languageOptions"
          form-group-id="Language"
          :placeholder="'Second language' | i18n"
          input-placeholder="select_translation_lang"
          required
        />
      </div>
      <div class="col-lg-12 col-sm-12 col-12">
        <Checkbox v-model="isReportWithTranslation" :placeholder="'additional_pdf_translate' | i18n" form-group-id="translationProjectListContent" />
      </div>
      <div v-if="isReportWithTranslation" class="col-lg-12 col-sm-12 col-12 mt-n4 mb-n4">
        <Select
          v-model="translateLanguage"
          :options="languageOptions"
          form-group-id="Language"
          :placeholder="'language' | i18n"
          input-placeholder="select_translation_lang"
          required
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import Select from '../../../../common/select';
import Checkbox from '../../../../common/checkbox';
import { TRANSLATE_LANGUAGE } from '../../../../../../../../../constants';

export default {
  name: 'SubmitModal',
  components: { Select, Checkbox },
  props: {
    id: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    completeProject: {
      type: Function,
      default: () => {},
    },
    isOnSiteSupportOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isTranslatedChatContent: false,
      isReportWithTranslation: false,
      firstChatTranslateLanguage: '',
      secondChatTranslateLanguage: '',
      translateLanguage: '',
      languageOptions: Object.keys(TRANSLATE_LANGUAGE).map((i) => ({ value: TRANSLATE_LANGUAGE[i], text: this.$translate(i) })),
    };
  },
  computed: {
    isDisabledSaveBtn: function () {
      if (
        (this.isReportWithTranslation && !this.translateLanguage) ||
        (this.isTranslatedChatContent && (!this.firstChatTranslateLanguage || !this.secondChatTranslateLanguage))
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    clear() {
      this.isTranslatedChatContent = false;
      this.isReportWithTranslation = false;
      this.translateLanguage = '';
      this.firstChatTranslateLanguage = '';
      this.secondChatTranslateLanguage = '';
    },
    save() {
      this.completeProject({
        silent: false,
        complete: true,
        translateLanguage: this.translateLanguage || null,
        firstChatTranslateLanguage: this.firstChatTranslateLanguage || null,
        secondChatTranslateLanguage: this.secondChatTranslateLanguage || null,
        isTranslatedChatContent: this.isTranslatedChatContent,
        isReportWithTranslation: this.isReportWithTranslation,
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px !important;
}

::v-deep .modal-footer {
  padding: 1.5rem;
  padding-top: 0;
  border: none;
  & > button {
    padding-right: 100px;
    padding-left: 100px;
    margin: 0;
  }
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
